import { render, staticRenderFns } from "./choose-preset-image.vue?vue&type=template&id=51aa359c&scoped=true&"
import script from "./choose-preset-image.vue?vue&type=script&lang=js&"
export * from "./choose-preset-image.vue?vue&type=script&lang=js&"
import style0 from "./choose-preset-image.vue?vue&type=style&index=0&id=51aa359c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa359c",
  null
  
)

export default component.exports